import { idb, TOKO } from './idb';
import { api, GalatJaringan } from './api';
import type { Katalog } from '@santap/shared';

/**
 * Katalog lokal.
 *
 * Kasir TIDAK PERNAH menunggu jaringan untuk menampilkan menu. Katalog dibaca
 * dari penyimpanan lokal, lalu penyegaran berjalan di latar. Kalau penyegaran
 * gagal, yang lama tetap dipakai — menu kemarin jauh lebih berguna daripada
 * layar kosong.
 */

const kunci = (outletId: string) => `katalog:${outletId}`;

export async function ambilKatalog(outletId: string): Promise<Katalog | undefined> {
  return idb.get<Katalog>(TOKO.katalog, kunci(outletId));
}

export async function segarkanKatalog(outletId: string): Promise<{
  katalog: Katalog | undefined;
  segar: boolean;
  pesan?: string;
}> {
  const lama = await ambilKatalog(outletId);
  try {
    const baru = await api.katalog(outletId);
    await idb.set(TOKO.katalog, baru, kunci(outletId));
    return {
      katalog: baru,
      segar: true,
      pesan: lama && baru.versi !== lama.versi ? 'Menu diperbarui' : undefined,
    };
  } catch (e) {
    if (e instanceof GalatJaringan && lama) {
      return { katalog: lama, segar: false, pesan: 'Memakai menu tersimpan' };
    }
    if (lama) return { katalog: lama, segar: false, pesan: 'Gagal menyegarkan menu' };
    throw e;
  }
}

/**
 * Nomor urut struk, disimpan lokal per terminal.
 *
 * Harus lokal: dua kasir yang sama-sama offline tidak bisa berkoordinasi, dan
 * penomoran dari server akan membuat kasir menunggu jaringan justru di saat
 * jaringan tidak ada. Keunikan dijamin gabungan (terminal, nomor) di basis data.
 */
export async function nomorBerikut(terminalId: string): Promise<number> {
  const k = `urut:${terminalId}:${new Date().toISOString().slice(0, 10)}`;
  const sekarang = (await idb.get<number>(TOKO.meta, k)) ?? 0;
  const berikut = sekarang + 1;
  await idb.set(TOKO.meta, berikut, k);
  return berikut;
}
